const eStorageKeys = {
  ESK_AGE_CONFIRM: 'epcyplay_age_confirm',
  ESK_COOKIES_ACCEPT: 'epcyplay_cookies_accept',
  ESK_ADMIN_TOKEN: 'epcyplay_admin_token',
};

export default eStorageKeys;
